import type { AxiosError, AxiosResponse } from 'axios'
import { promiseTimeout } from '@vueuse/core'
import { router } from '@/router'
import { routeNames } from '@/router/route-names'

const responseInterceptor = (response: AxiosResponse): Promise<AxiosResponse> => {
  return response.data
}

const errorInterceptor = async (error: AxiosError<any>): Promise<AxiosError> => {
  if (error?.response?.status === 401) {
    const impersonateToken = cookieService.getCookie('impersonateToken')

    if (impersonateToken) {
      cookieService.deleteCookie('impersonateToken')
      useNotification({ type: 'warning', title: errorService.codes.IMPERSONATION_EXPIRED.title, message: errorService.codes.IMPERSONATION_EXPIRED.message })
      await promiseTimeout(1500)
      window.location.href = router.resolve({ name: routeNames.spencerAdminSchools }).href
    } else {
      useNotification({ type: 'warning', title: errorService.codes.SESSION_EXPIRED.title, message: errorService.codes.SESSION_EXPIRED.message })
      await promiseTimeout(1500)
      await useAuthStore().handleSignOut()
    }
  } else if (error?.response?.status === 429) {
    if (!error.config?.skipErrorNotification) {
      useNotification({ type: 'warning', title: errorService.codes.RATE_LIMIT_EXCEEDED.title, message: errorService.codes.RATE_LIMIT_EXCEEDED.message })
    }
  } else if (!error.config?.skipErrorNotification) {
    useNotification({ type: 'error', message: errorService.getErrorMessage(error) })
  }

  return Promise.reject(error)
}

export {
  responseInterceptor,
  errorInterceptor
}
